import createProps from '@kissui/helpers/src/props.helpers'

class Counter extends HTMLElement {
    constructor() {
        super()
        this.props = {}
        this.intervalM = null
    }

    connectedCallback() {
        this.props = createProps(this.attributes)
        this.render()
    }

    render() {
        const { date, time = '00:00:00', locale = {} } = this.props
        if (!date) {
            return
        }
        const cleanLocale = typeof locale === 'string' ? JSON.parse(locale) : locale
        const dateTime = `${date} ${time}`
        const countDownDate = new Date(dateTime).getTime()

        if (this.checkDifference(countDownDate) <= 0) {
            this.setEndAttribute()
            return
        }

        this.reRenderTime(countDownDate, cleanLocale)
        this.intervalM = setInterval(() => this.reRenderTime(countDownDate, cleanLocale), 1000)
    }

    renderTime(val, text) {
        return `${val}${text}`
    }

    reRenderTime(countDownDate, locale) {
        const normalizeTime = operation => {
            const floor = Math.floor(operation)
            return ('0' + floor).slice(-2)
        }

        const difference = this.checkDifference(countDownDate)
        const days = normalizeTime(difference / (1000 * 60 * 60 * 24))
        const hours = normalizeTime((difference % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60))
        const minutes = normalizeTime((difference % (1000 * 60 * 60)) / (1000 * 60))
        const seconds = normalizeTime((difference % (1000 * 60)) / 1000)

        this.innerHTML = `<strong>${this.renderTime(days, locale.days)}  ${this.renderTime(
            hours,
            locale.hours
        )} ${this.renderTime(minutes, locale.minutes)} ${this.renderTime(
            seconds,
            locale.seconds
        )}</strong>`

        if (difference <= 0) {
            if (this.intervalM) {
                clearInterval(this.intervalM)
            }
            this.innerHTML = ''
            this.setEndAttribute()
        }
    }

    setEndAttribute() {
        this.setAttribute('countdown-end', 'true')
    }

    checkDifference(countDownDate) {
        const dateNow = new Date().getTime()
        return countDownDate - dateNow
    }

    disconnectedCallback() {
        if (this.intervalM) {
            clearInterval(this.intervalM)
        }
    }
}

customElements.get('nb-countdown') || customElements.define('nb-countdown', Counter)

export default Counter
